import { GetInTouchProps } from 'components/commercial/get-in-touch';
import { LOCALE_EXP_COMMERCIAL_PATHS } from 'types/locales';

export const getInTouchConfig: GetInTouchProps = {
  mediaType: 'video',
  autoPlay: true,
  webmSrc: '/next/assets/videos/commercial/commercial-get-in-touch.webm',
  mp4Src: '/next/assets/videos/commercial/commercial-get-in-touch.mp4',
  title: LOCALE_EXP_COMMERCIAL_PATHS.GET_IN_TOUCH_TITLE,
  description: LOCALE_EXP_COMMERCIAL_PATHS.GET_IN_TOUCH_DESCRIPTION,
  contactButton: LOCALE_EXP_COMMERCIAL_PATHS.GET_IN_TOUCH_CONTACT_BUTTON,
  joinButton: LOCALE_EXP_COMMERCIAL_PATHS.GET_IN_TOUCH_JOIN_BUTTON,
};

